// extracted by mini-css-extract-plugin
export default {"container":"Editor_container__mwY--","contentWrapper":"Editor_contentWrapper__x8gkb","loaderContainer":"Editor_loaderContainer__KZTML"};